<template>
    <div class="survey-radio-group-container">
        <p>{{field.name}}</p>
        <div class="radio-container">
            <div class="radio-wrapper" v-for="(child, index) in field.children" v-bind:key="index">
                <md-radio v-model="model" :value="child.index" class="md-primary"
                          @change="onModelChange">{{child.name}}</md-radio>
                <div class="radio-children" v-if="model === child.index">
                    <survey-field v-for="(radioChild, childIndex) in child.children"
                                  v-bind:key="childIndex"
                                  v-bind:field="radioChild"></survey-field>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable radix */
export default {
  name: 'SurveyRadioGroup',
  data() {
    return {
      blured: false,
      model: parseInt(this.field.value),
    };
  },
  methods: {
    onModelChange() {
      if (this.field.value != this.model) {
        this.$emit('modelChange', {
          newVal: this.model,
          oldVal: this.field.value,
          fieldId: this.field.id,
        });
        this.field.value = this.model;
        this.$emit('nodeChange', this.field);
        this.clearChildren(this.field.children[this.model]);
      }
    },
    clearChildren(node) {
      node.children.forEach((child) => {
        delete child.value;
        if (child.children) {
          this.clearChildren(child);
        }
      });
    },
  },
  props: ['field'],
};
</script>

<style src="./SurveyRadioGroup.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SurveyRadioGroup/SurveyRadioGroup.vue